import Header from "../components/Header";
import Footer from "../components/Footer";
import Head from "../components/Head";
import Script from "next/script";
import * as common from "../common/commonFunction";
import commonSession from "../common/commonSession";
import { useState, useEffect } from "react";
import $ from "jquery";
import axios from "axios";
import { isMobile } from "react-device-detect";

const Registration = () => {
  // get today date
  const current = new Date();
  const today_day = current.getDate();
  const today_month = current.getMonth() + 1;
  const today_year = current.getFullYear();
  const next_year = today_year + 1;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [code, setCode] = useState("");
  const [nickName, setNickName] = useState("");
  const [userMail, setUserMail] = useState("");
  const [pw, setPw] = useState("");
  const [pw_cf, setPwcf] = useState("");
  const [selectCountryGroup, setSelectCountryGroup] = useState("");
  const [selectCountry, setSelectCountry] = useState("KR");
  const [referralCodes, setReferralCodes] = useState("");
  const [inviterEmail, setInviterEmail] = useState(null);
  const [inviterEmailVerify, setInviterEmailVerify] = useState("");

  const handleChange = (e) => {
    $(".invalid-feedback").hide();
    e.target.classList.remove("error");
    e.target.classList.add("success");

    if (e.target.name == "firstName") {
      setFirstName(e.target.value);
    } else if (e.target.name == "inviterEmail") {
      setInviterEmail(e.target.value);
    } else if (e.target.name == "lastName") {
      setLastName(e.target.value);
    } else if (e.target.name == "code") {
      setCode(e.target.value);
    } else if (e.target.name == "nickName") {
      setNickName(e.target.value);
    } else if (e.target.name == "userMail") {
      setUserMail(e.target.value);
    } else if (e.target.name == "pw") {
      setPw(e.target.value);

      if (e.target.value != pw_cf) {
        $(".invalid-feedback.pw_cf").show();
        e.target.classList.remove("success");
        e.target.classList.add("error");
        $("#pw").focus();
      }
    } else if (e.target.name == "pw_cf") {
      setPwcf(e.target.value);

      if (e.target.value != pw) {
        $(".invalid-feedback.pw_cf").show();
        e.target.classList.remove("success");
        e.target.classList.add("error");
        $("#pw_cf").focus();
      } else {
        $("#pw").removeClass("error");
        $("#pw").addClass("success");
        $("#pw_cf").removeClass("error");
        $("#pw_cf").addClass("success");
      }
    } else if (e.target.name == "country") {
      setSelectCountry(e.target.value);
    } else if (e.target.name == "country-group") {
      setSelectCountryGroup(e.target.value);

      $('select[name="country"]').css("display", "block");
      $('select[name="country"]').find("option").css("display", "none");
      $('select[name="country"]')
        .find("option." + e.target.value)
        .css("display", "block");
    } else if (e.target.name == "referralCodes") {
      setReferralCodes(e.target.value);
    }
  };

  // join function
  const joinFunc = () => {
    var flag = true;
    $(".invalid-feedback").hide();

    if (nickName == "") {
      flag = false;
      $(".invalid-feedback.nickName").show();
      $("#nickname").removeClass("success");
      $("#nickname").addClass("error");
      $("#nickname").focus();
    }

    if (pw == "") {
      flag = false;
      $(".invalid-feedback.pw").show();
      $("#pw").removeClass("success");
      $("#pw").addClass("error");
      $("#pw").focus();
    }

    if (pw != pw_cf) {
      flag = false;
      $(".invalid-feedback.pw_cf").show();
      $("#pw_cf").removeClass("success");
      $("#pw_cf").addClass("error");
      $("#pw_cf").focus();
    } else {
      $("#pw").removeClass("error");
      $("#pw").addClass("success");
      $("#pw_cf").removeClass("error");
      $("#pw_cf").addClass("success");
    }

    var nickFlag = $(".nickCheckBtn").css("display");

    if (nickFlag != "none") {
      flag = false;
      alert("닉네임 중복확인을 진행해주세요.");
      $("#nickname").removeClass("success");
      $("#nickname").addClass("error");
      $("#nickName").focus();
    }

    var emailVerify = $(".sendEmail").css("display");

    if (emailVerify != "none") {
      flag = false;
      alert("이메일 인증을 진행해주세요");
      $("#userMail").removeClass("success");
      $("#userMail").addClass("error");
      $("#userMail").focus();
    }

    $('input[type="checkbox"]').each(function (i, e) {
      if ($(e).prop("required")) {
        if (!$(e).is(":checked")) {
          $(e).focus();
          alert("필수항목을 체크해주세요!");
          flag = false;
        }
      }
    });

    console.log(flag);

    if (flag) {
      // firstName: firstName, lastName: lastName,
      var data = {
        email: userMail,
        nickName: nickName,
        password: pw,
        country: selectCountry,
        inviterEmail: inviterEmail
      };

      var jsonData = JSON.stringify(data);

      console.log(jsonData);

      const option = {
        url: "/users/register",
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8"
        },
        data: jsonData
      };

      axios(option)
        .then((result) => {
          console.log(result);
          // return false;
          if (result.data.status == 200) {
            $(".toast .toast-body").html(
              "가입이 완료되었습니다!\n로그인을 해주세요 :-)"
            );
            $(".toast").show();
            $(".toast").css("opacity", 1);

            setTimeout(() => {
              location.replace("/login");
            }, 4000);
          } else {
            $(".toast .toast-body").html(result.data.message ?? "");
            $(".toast").show();
            $(".toast").css("opacity", 1);

            setTimeout(() => {
              $(".toast").hide();
            }, 4000);

            $(".modal").hide();
            return false;
          }
        })
        .catch((error) => {
          $(".toast .toast-body").html(
            "서버 연결 도중 에러가 났습니다. 다시 시도해 주십시오."
          );
          $(".toast").show();
          $(".toast").css("opacity", 1);

          setTimeout(() => {
            $(".toast").hide();
          }, 4000);

          return false;
        });
    }
  };

  // 추천인아이디 존재 여부
  const checkInviterEmail = () => {
    const option = {
      url: "/users/checkInviter?inviterEmail=" + inviterEmail,
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8"
      }
    };

    axios(option)
      .then((result) => {
        if (result.data.status == 200) {
          $(".toast .toast-body").html("입력 가능한 추천인 아이디 입니다.");
          $(".toast").show();
          $(".toast").css("opacity", 1);

          setTimeout(() => {
            $(".toast").hide();
          }, 4000);

          setInviterEmailVerify("Y");
        } else {
          $(".toast .toast-body").html(result.data.message);
          $(".toast").show();
          $(".toast").css("opacity", 1);

          setTimeout(() => {
            $(".toast").hide();
          }, 4000);

          $(".modal").hide();

          setInviterEmail("");
          $('[name="inviterEmailVerify"]').val("");

          return false;
        }
      })
      .catch((error) => {
        $(".toast .toast-body").html(
          "서버 연결 도중 에러가 났습니다. 다시 시도해 주십시오."
        );
        $(".toast").show();
        $(".toast").css("opacity", 1);
        setTimeout(() => {
          $(".toast").hide();
        }, 3000);
        return false;
      });
  };

  // 이용약관 읽음 여부

  const [readTermUse, setReadTermUse] = useState(false);
  const [readTermPrivacy, setReadTermPrivacy] = useState(false);

  return (
    <>
      <Head />
      <Header />
      <link rel="stylesheet" href="/css/join.min.css" />
      <div
        className="container"
        id="join"
        onClick={() => common.focusOutMenu()}
      >
        <content>
          <div className="input-form">
            <h3
              className="text-center fs-2 w-70"
              style={{ margin: "0 auto 17px" }}
            >
              일반 회원가입
            </h3>
            <p
              className="text-center fs-6 w-70"
              style={{ margin: "0 auto 12px" }}
            >
              회원가입하고 밈비와 함께 하세요
            </p>

            <a href="/registrationCorp">
              <p
                className="text-center fs-6 w-70 text-decoration-underline"
                style={{ margin: "0 auto 42px" }}
              >
                기업회원가입 하러가기
              </p>
            </a>

            <form className="validation-form" noValidate>
              <div className="row align-items-end">
                <div className="col-9">
                  <input type="hidden" name="nickFlag" value=""></input>
                  <label htmlFor="nickName" className="form-label">
                    닉네임 <span className="required-icon">*</span>
                  </label>{" "}
                  <input
                    type="text"
                    className="form-control box"
                    id="nickname"
                    placeholder="Nickname"
                    value={nickName}
                    name="nickName"
                    onChange={handleChange}
                    required
                  />
                  <div className="invalid-feedback nickname">
                    * 중복된 닉네임입니다. 다른 닉네임을 입력해주세요.
                  </div>
                </div>
                <div className="col-3">
                  <label htmlFor="nicknameCheck" className="form-label">
                    {" "}
                  </label>
                  <input
                    type="button"
                    className="w-100 btn basicBtn nickCheckBtn"
                    value="중복확인"
                    onClick={() => common.chk_nickname()}
                  />
                </div>
              </div>

              <div className="row align-items-end">
                <div className="col-9">
                  <label htmlFor="firstName" className="form-label">
                    이메일 <span className="required-icon">*</span>
                  </label>{" "}
                  <input
                    type="text"
                    className="form-control box"
                    id="userMail"
                    placeholder="Example@example.com"
                    value={userMail}
                    name="userMail"
                    onChange={handleChange}
                    required
                  />
                  <div className="invalid-feedback userMail">
                    *이메일을 입력해 주세요
                  </div>
                </div>
                <div className="col-3">
                  <input type="hidden" name="emailVerify" value=""></input>
                  <label htmlFor="userMailCheck" className="form-label">
                    {" "}
                  </label>
                  <input
                    type="button"
                    className="btn basicBtn sendEmail w-100"
                    value="인증받기"
                    onClick={() => common.email_send()}
                  />
                  <div className="email-verificate">
                    <input
                      type="text"
                      className="box mt-2 mb-2"
                      name="code"
                      value={code}
                      placeholder="Enter code"
                      onChange={handleChange}
                      style={{ margin: ".5rem 0px" }}
                    />
                    <input
                      type="button"
                      className="btn basicBtn w-100"
                      value="인증완료"
                      style={{ margin: ".5rem 0px" }}
                      onClick={() => common.verifyCode()}
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="pw" className="form-label">
                  비밀번호 <span className="required-icon">*</span>
                </label>
                <input
                  type="password"
                  className="form-control box"
                  id="pw"
                  name="pw"
                  placeholder="비밀번호 입력"
                  minLength="6"
                  value={pw}
                  onChange={handleChange}
                  required
                />
                <input
                  type="password"
                  id="pw_cf"
                  name="pw_cf"
                  className="form-control box"
                  placeholder="비밀번호 확인"
                  minLength="6"
                  value={pw_cf}
                  maxlength="20"
                  onChange={handleChange}
                  required
                />
                <div className="invalid-feedback pw">
                  *6자 이상 입력해주세요
                </div>
                <div className="invalid-feedback pw_cf">
                  *비밀번호가 일치하지 않습니다.
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="pw" className="form-label">
                  국가
                </label>
                <div className="d-flex">
                  <select
                    name="country-group"
                    value={selectCountryGroup}
                    className="form-control box"
                    id="country-group"
                    onChange={handleChange}
                  >
                    <option value="0" label="선택" selected="selected">
                      선택
                    </option>
                    <option id="country-optgroup-Africa" value="Africa">
                      Africa
                    </option>
                    <option id="country-optgroup-Americas" value="Americas">
                      Americas
                    </option>
                    <option id="country-optgroup-Asia" value="Asia">
                      Asia
                    </option>
                    <option id="country-optgroup-Europe" value="Europe">
                      Europe
                    </option>
                    <option id="country-optgroup-Oceania" value="Oceania">
                      Oceania
                    </option>
                  </select>
                  <select
                    name="country"
                    value={selectCountry}
                    className="form-control box"
                    id="country"
                    onChange={handleChange}
                    style={{ display: "none" }}
                  >
                    <option value="0" label="선택" selected="selected">
                      선택
                    </option>
                    <option value="DZ" label="Algeria" className="Africa">
                      Algeria
                    </option>
                    <option value="AO" label="Angola" className="Africa">
                      Angola
                    </option>
                    <option value="BJ" label="Benin" className="Africa">
                      Benin
                    </option>
                    <option value="BW" label="Botswana" className="Africa">
                      Botswana
                    </option>
                    <option value="BF" label="Burkina Faso" className="Africa">
                      Burkina Faso
                    </option>
                    <option value="BI" label="Burundi" className="Africa">
                      Burundi
                    </option>
                    <option value="CM" label="Cameroon" className="Africa">
                      Cameroon
                    </option>
                    <option value="CV" label="Cape Verde" className="Africa">
                      Cape Verde
                    </option>
                    <option
                      value="CF"
                      label="Central African Republic"
                      className="Africa"
                    >
                      Central African Republic
                    </option>
                    <option value="TD" label="Chad" className="Africa">
                      Chad
                    </option>
                    <option value="KM" label="Comoros" className="Africa">
                      Comoros
                    </option>
                    <option
                      value="CG"
                      label="Congo - Brazzaville"
                      className="Africa"
                    >
                      Congo - Brazzaville
                    </option>
                    <option
                      value="CD"
                      label="Congo - Kinshasa"
                      className="Africa"
                    >
                      Congo - Kinshasa
                    </option>
                    <option
                      value="CI"
                      label="CÃ´te dâIvoire"
                      className="Africa"
                    >
                      CÃ´te dâIvoire
                    </option>
                    <option value="DJ" label="Djibouti" className="Africa">
                      Djibouti
                    </option>
                    <option value="EG" label="Egypt" className="Africa">
                      Egypt
                    </option>
                    <option
                      value="GQ"
                      label="Equatorial Guinea"
                      className="Africa"
                    >
                      Equatorial Guinea
                    </option>
                    <option value="ER" label="Eritrea" className="Africa">
                      Eritrea
                    </option>
                    <option value="ET" label="Ethiopia" className="Africa">
                      Ethiopia
                    </option>
                    <option value="GA" label="Gabon" className="Africa">
                      Gabon
                    </option>
                    <option value="GM" label="Gambia" className="Africa">
                      Gambia
                    </option>
                    <option value="GH" label="Ghana" className="Africa">
                      Ghana
                    </option>
                    <option value="GN" label="Guinea" className="Africa">
                      Guinea
                    </option>
                    <option value="GW" label="Guinea-Bissau" className="Africa">
                      Guinea-Bissau
                    </option>
                    <option value="KE" label="Kenya" className="Africa">
                      Kenya
                    </option>
                    <option value="LS" label="Lesotho" className="Africa">
                      Lesotho
                    </option>
                    <option value="LR" label="Liberia" className="Africa">
                      Liberia
                    </option>
                    <option value="LY" label="Libya" className="Africa">
                      Libya
                    </option>
                    <option value="MG" label="Madagascar" className="Africa">
                      Madagascar
                    </option>
                    <option value="MW" label="Malawi" className="Africa">
                      Malawi
                    </option>
                    <option value="ML" label="Mali" className="Africa">
                      Mali
                    </option>
                    <option value="MR" label="Mauritania" className="Africa">
                      Mauritania
                    </option>
                    <option value="MU" label="Mauritius" className="Africa">
                      Mauritius
                    </option>
                    <option value="YT" label="Mayotte" className="Africa">
                      Mayotte
                    </option>
                    <option value="MA" label="Morocco" className="Africa">
                      Morocco
                    </option>
                    <option value="MZ" label="Mozambique" className="Africa">
                      Mozambique
                    </option>
                    <option value="NA" label="Namibia" className="Africa">
                      Namibia
                    </option>
                    <option value="NE" label="Niger" className="Africa">
                      Niger
                    </option>
                    <option value="NG" label="Nigeria" className="Africa">
                      Nigeria
                    </option>
                    <option value="RW" label="Rwanda" className="Africa">
                      Rwanda
                    </option>
                    <option value="RE" label="RÃ©union" className="Africa">
                      RÃ©union
                    </option>
                    <option value="SH" label="Saint Helena" className="Africa">
                      Saint Helena
                    </option>
                    <option value="SN" label="Senegal" className="Africa">
                      Senegal
                    </option>
                    <option value="SC" label="Seychelles" className="Africa">
                      Seychelles
                    </option>
                    <option value="SL" label="Sierra Leone" className="Africa">
                      Sierra Leone
                    </option>
                    <option value="SO" label="Somalia" className="Africa">
                      Somalia
                    </option>
                    <option value="ZA" label="South Africa" className="Africa">
                      South Africa
                    </option>
                    <option value="SD" label="Sudan" className="Africa">
                      Sudan
                    </option>
                    <option value="SZ" label="Swaziland" className="Africa">
                      Swaziland
                    </option>
                    <option
                      value="ST"
                      label="SÃ£o TomÃ© and PrÃ­ncipe"
                      className="Africa"
                    >
                      SÃ£o TomÃ© and PrÃ­ncipe
                    </option>
                    <option value="TZ" label="Tanzania" className="Africa">
                      Tanzania
                    </option>
                    <option value="TG" label="Togo" className="Africa">
                      Togo
                    </option>
                    <option value="TN" label="Tunisia" className="Africa">
                      Tunisia
                    </option>
                    <option value="UG" label="Uganda" className="Africa">
                      Uganda
                    </option>
                    <option
                      value="EH"
                      label="Western Sahara"
                      className="Africa"
                    >
                      Western Sahara
                    </option>
                    <option value="ZM" label="Zambia" className="Africa">
                      Zambia
                    </option>
                    <option value="ZW" label="Zimbabwe" className="Africa">
                      Zimbabwe
                    </option>
                    \
                    <option value="AI" label="Anguilla" className="Americas">
                      Anguilla
                    </option>
                    <option
                      value="AG"
                      label="Antigua and Barbuda"
                      className="Americas"
                    >
                      Antigua and Barbuda
                    </option>
                    <option value="AR" label="Argentina" className="Americas">
                      Argentina
                    </option>
                    <option value="AW" label="Aruba" className="Americas">
                      Aruba
                    </option>
                    <option value="BS" label="Bahamas" className="Americas">
                      Bahamas
                    </option>
                    <option value="BB" label="Barbados" className="Americas">
                      Barbados
                    </option>
                    <option value="BZ" label="Belize" className="Americas">
                      Belize
                    </option>
                    <option value="BM" label="Bermuda" className="Americas">
                      Bermuda
                    </option>
                    <option value="BO" label="Bolivia" className="Americas">
                      Bolivia
                    </option>
                    <option value="BR" label="Brazil" className="Americas">
                      Brazil
                    </option>
                    <option
                      value="VG"
                      label="British Virgin Islands"
                      className="Americas"
                    >
                      British Virgin Islands
                    </option>
                    <option value="CA" label="Canada" className="Americas">
                      Canada
                    </option>
                    <option
                      value="KY"
                      label="Cayman Islands"
                      className="Americas"
                    >
                      Cayman Islands
                    </option>
                    <option value="CL" label="Chile" className="Americas">
                      Chile
                    </option>
                    <option value="CO" label="Colombia" className="Americas">
                      Colombia
                    </option>
                    <option value="CR" label="Costa Rica" className="Americas">
                      Costa Rica
                    </option>
                    <option value="CU" label="Cuba" className="Americas">
                      Cuba
                    </option>
                    <option value="DM" label="Dominica" className="Americas">
                      Dominica
                    </option>
                    <option
                      value="DO"
                      label="Dominican Republic"
                      className="Americas"
                    >
                      Dominican Republic
                    </option>
                    <option value="EC" label="Ecuador" className="Americas">
                      Ecuador
                    </option>
                    <option value="SV" label="El Salvador" className="Americas">
                      El Salvador
                    </option>
                    <option
                      value="FK"
                      label="Falkland Islands"
                      className="Americas"
                    >
                      Falkland Islands
                    </option>
                    <option
                      value="GF"
                      label="French Guiana"
                      className="Americas"
                    >
                      French Guiana
                    </option>
                    <option value="GL" label="Greenland" className="Americas">
                      Greenland
                    </option>
                    <option value="GD" label="Grenada" className="Americas">
                      Grenada
                    </option>
                    <option value="GP" label="Guadeloupe" className="Americas">
                      Guadeloupe
                    </option>
                    <option value="GT" label="Guatemala" className="Americas">
                      Guatemala
                    </option>
                    <option value="GY" label="Guyana" className="Americas">
                      Guyana
                    </option>
                    <option value="HT" label="Haiti" className="Americas">
                      Haiti
                    </option>
                    <option value="HN" label="Honduras" className="Americas">
                      Honduras
                    </option>
                    <option value="JM" label="Jamaica" className="Americas">
                      Jamaica
                    </option>
                    <option value="MQ" label="Martinique" className="Americas">
                      Martinique
                    </option>
                    <option value="MX" label="Mexico" className="Americas">
                      Mexico
                    </option>
                    <option value="MS" label="Montserrat" className="Americas">
                      Montserrat
                    </option>
                    <option
                      value="AN"
                      label="Netherlands Antilles"
                      className="Americas"
                    >
                      Netherlands Antilles
                    </option>
                    <option value="NI" label="Nicaragua" className="Americas">
                      Nicaragua
                    </option>
                    <option value="PA" label="Panama" className="Americas">
                      Panama
                    </option>
                    <option value="PY" label="Paraguay" className="Americas">
                      Paraguay
                    </option>
                    <option value="PE" label="Peru" className="Americas">
                      Peru
                    </option>
                    <option value="PR" label="Puerto Rico" className="Americas">
                      Puerto Rico
                    </option>
                    <option
                      value="BL"
                      label="Saint BarthÃ©lemy"
                      className="Americas"
                    >
                      Saint BarthÃ©lemy
                    </option>
                    <option
                      value="KN"
                      label="Saint Kitts and Nevis"
                      className="Americas"
                    >
                      Saint Kitts and Nevis
                    </option>
                    <option value="LC" label="Saint Lucia" className="Americas">
                      Saint Lucia
                    </option>
                    <option
                      value="MF"
                      label="Saint Martin"
                      className="Americas"
                    >
                      Saint Martin
                    </option>
                    <option
                      value="PM"
                      label="Saint Pierre and Miquelon"
                      className="Americas"
                    >
                      Saint Pierre and Miquelon
                    </option>
                    <option
                      value="VC"
                      label="Saint Vincent and the Grenadines"
                      className="Americas"
                    >
                      Saint Vincent and the Grenadines
                    </option>
                    <option value="SR" label="Suriname" className="Americas">
                      Suriname
                    </option>
                    <option
                      value="TT"
                      label="Trinidad and Tobago"
                      className="Americas"
                    >
                      Trinidad and Tobago
                    </option>
                    <option
                      value="TC"
                      label="Turks and Caicos Islands"
                      className="Americas"
                    >
                      Turks and Caicos Islands
                    </option>
                    <option
                      value="VI"
                      label="U.S. Virgin Islands"
                      className="Americas"
                    >
                      U.S. Virgin Islands
                    </option>
                    <option
                      value="US"
                      label="United States"
                      className="Americas"
                    >
                      United States
                    </option>
                    <option value="UY" label="Uruguay" className="Americas">
                      Uruguay
                    </option>
                    <option value="VE" label="Venezuela" className="Americas">
                      Venezuela
                    </option>
                    <option value="AF" label="Afghanistan" className="Asia">
                      Afghanistan
                    </option>
                    <option value="AM" label="Armenia" className="Asia">
                      Armenia
                    </option>
                    <option value="AZ" label="Azerbaijan" className="Asia">
                      Azerbaijan
                    </option>
                    <option value="BH" label="Bahrain" className="Asia">
                      Bahrain
                    </option>
                    <option value="BD" label="Bangladesh" className="Asia">
                      Bangladesh
                    </option>
                    <option value="BT" label="Bhutan" className="Asia">
                      Bhutan
                    </option>
                    <option value="BN" label="Brunei" className="Asia">
                      Brunei
                    </option>
                    <option value="KH" label="Cambodia" className="Asia">
                      Cambodia
                    </option>
                    <option value="CN" label="China" className="Asia">
                      China
                    </option>
                    <option value="GE" label="Georgia" className="Asia">
                      Georgia
                    </option>
                    <option
                      value="HK"
                      label="Hong Kong SAR China"
                      className="Asia"
                    >
                      Hong Kong SAR China
                    </option>
                    <option value="IN" label="India" className="Asia">
                      India
                    </option>
                    <option value="ID" label="Indonesia" className="Asia">
                      Indonesia
                    </option>
                    <option value="IR" label="Iran" className="Asia">
                      Iran
                    </option>
                    <option value="IQ" label="Iraq" className="Asia">
                      Iraq
                    </option>
                    <option value="IL" label="Israel" className="Asia">
                      Israel
                    </option>
                    <option value="JP" label="Japan" className="Asia">
                      Japan
                    </option>
                    <option value="JO" label="Jordan" className="Asia">
                      Jordan
                    </option>
                    <option value="KZ" label="Kazakhstan" className="Asia">
                      Kazakhstan
                    </option>
                    <option value="KW" label="Kuwait" className="Asia">
                      Kuwait
                    </option>
                    <option value="KG" label="Kyrgyzstan" className="Asia">
                      Kyrgyzstan
                    </option>
                    <option value="LA" label="Laos" className="Asia">
                      Laos
                    </option>
                    <option value="LB" label="Lebanon" className="Asia">
                      Lebanon
                    </option>
                    <option value="MO" label="Macau SAR China" className="Asia">
                      Macau SAR China
                    </option>
                    <option value="MY" label="Malaysia" className="Asia">
                      Malaysia
                    </option>
                    <option value="MV" label="Maldives" className="Asia">
                      Maldives
                    </option>
                    <option value="MN" label="Mongolia" className="Asia">
                      Mongolia
                    </option>
                    <option value="MM" label="Myanmar [Burma]" className="Asia">
                      Myanmar [Burma]
                    </option>
                    <option value="NP" label="Nepal" className="Asia">
                      Nepal
                    </option>
                    <option value="NT" label="Neutral Zone" className="Asia">
                      Neutral Zone
                    </option>
                    <option value="KP" label="North Korea" className="Asia">
                      North Korea
                    </option>
                    <option value="OM" label="Oman" className="Asia">
                      Oman
                    </option>
                    <option value="PK" label="Pakistan" className="Asia">
                      Pakistan
                    </option>
                    <option
                      value="PS"
                      label="Palestinian Territories"
                      className="Asia"
                    >
                      Palestinian Territories
                    </option>
                    <option
                      value="YD"
                      label="People's Democratic Republic of Yemen"
                      className="Asia"
                    >
                      People's Democratic Republic of Yemen
                    </option>
                    <option value="PH" label="Philippines" className="Asia">
                      Philippines
                    </option>
                    <option value="QA" label="Qatar" className="Asia">
                      Qatar
                    </option>
                    <option value="SA" label="Saudi Arabia" className="Asia">
                      Saudi Arabia
                    </option>
                    <option value="SG" label="Singapore" className="Asia">
                      Singapore
                    </option>
                    <option value="KR" label="South Korea" className="Asia">
                      South Korea
                    </option>
                    <option value="LK" label="Sri Lanka" className="Asia">
                      Sri Lanka
                    </option>
                    <option value="SY" label="Syria" className="Asia">
                      Syria
                    </option>
                    <option value="TW" label="Taiwan" className="Asia">
                      Taiwan
                    </option>
                    <option value="TJ" label="Tajikistan" className="Asia">
                      Tajikistan
                    </option>
                    <option value="TH" label="Thailand" className="Asia">
                      Thailand
                    </option>
                    <option value="TL" label="Timor-Leste" className="Asia">
                      Timor-Leste
                    </option>
                    <option value="TR" label="Turkey" className="Asia">
                      Turkey
                    </option>
                    <option value="TM" label="Turkmenistan" className="Asia">
                      Turkmenistan
                    </option>
                    <option
                      value="AE"
                      label="United Arab Emirates"
                      className="Asia"
                    >
                      United Arab Emirates
                    </option>
                    <option value="UZ" label="Uzbekistan" className="Asia">
                      Uzbekistan
                    </option>
                    <option value="VN" label="Vietnam" className="Asia">
                      Vietnam
                    </option>
                    <option value="YE" label="Yemen" className="Asia">
                      Yemen
                    </option>
                    <option value="AL" label="Albania" className="Europe">
                      Albania
                    </option>
                    <option value="AD" label="Andorra" className="Europe">
                      Andorra
                    </option>
                    <option value="AT" label="Austria" className="Europe">
                      Austria
                    </option>
                    <option value="BY" label="Belarus" className="Europe">
                      Belarus
                    </option>
                    <option value="BE" label="Belgium" className="Europe">
                      Belgium
                    </option>
                    <option
                      value="BA"
                      label="Bosnia and Herzegovina"
                      className="Europe"
                    >
                      Bosnia and Herzegovina
                    </option>
                    <option value="BG" label="Bulgaria" className="Europe">
                      Bulgaria
                    </option>
                    <option value="HR" label="Croatia" className="Europe">
                      Croatia
                    </option>
                    <option value="CY" label="Cyprus" className="Europe">
                      Cyprus
                    </option>
                    <option
                      value="CZ"
                      label="Czech Republic"
                      className="Europe"
                    >
                      Czech Republic
                    </option>
                    <option value="DK" label="Denmark" className="Europe">
                      Denmark
                    </option>
                    <option value="DD" label="East Germany" className="Europe">
                      East Germany
                    </option>
                    <option value="EE" label="Estonia" className="Europe">
                      Estonia
                    </option>
                    <option value="FO" label="Faroe Islands" className="Europe">
                      Faroe Islands
                    </option>
                    <option value="FI" label="Finland" className="Europe">
                      Finland
                    </option>
                    <option value="FR" label="France" className="Europe">
                      France
                    </option>
                    <option value="DE" label="Germany" className="Europe">
                      Germany
                    </option>
                    <option value="GI" label="Gibraltar" className="Europe">
                      Gibraltar
                    </option>
                    <option value="GR" label="Greece" className="Europe">
                      Greece
                    </option>
                    <option value="GG" label="Guernsey" className="Europe">
                      Guernsey
                    </option>
                    <option value="HU" label="Hungary" className="Europe">
                      Hungary
                    </option>
                    <option value="IS" label="Iceland" className="Europe">
                      Iceland
                    </option>
                    <option value="IE" label="Ireland" className="Europe">
                      Ireland
                    </option>
                    <option value="IM" label="Isle of Man" className="Europe">
                      Isle of Man
                    </option>
                    <option value="IT" label="Italy" className="Europe">
                      Italy
                    </option>
                    <option value="JE" label="Jersey" className="Europe">
                      Jersey
                    </option>
                    <option value="LV" label="Latvia" className="Europe">
                      Latvia
                    </option>
                    <option value="LI" label="Liechtenstein" className="Europe">
                      Liechtenstein
                    </option>
                    <option value="LT" label="Lithuania" className="Europe">
                      Lithuania
                    </option>
                    <option value="LU" label="Luxembourg" className="Europe">
                      Luxembourg
                    </option>
                    <option value="MK" label="Macedonia" className="Europe">
                      Macedonia
                    </option>
                    <option value="MT" label="Malta" className="Europe">
                      Malta
                    </option>
                    <option
                      value="FX"
                      label="Metropolitan France"
                      className="Europe"
                    >
                      Metropolitan France
                    </option>
                    <option value="MD" label="Moldova" className="Europe">
                      Moldova
                    </option>
                    <option value="MC" label="Monaco" className="Europe">
                      Monaco
                    </option>
                    <option value="ME" label="Montenegro" className="Europe">
                      Montenegro
                    </option>
                    <option value="NL" label="Netherlands" className="Europe">
                      Netherlands
                    </option>
                    <option value="NO" label="Norway" className="Europe">
                      Norway
                    </option>
                    <option value="PL" label="Poland" className="Europe">
                      Poland
                    </option>
                    <option value="PT" label="Portugal" className="Europe">
                      Portugal
                    </option>
                    <option value="RO" label="Romania" className="Europe">
                      Romania
                    </option>
                    <option value="RU" label="Russia" className="Europe">
                      Russia
                    </option>
                    <option value="SM" label="San Marino" className="Europe">
                      San Marino
                    </option>
                    <option value="RS" label="Serbia" className="Europe">
                      Serbia
                    </option>
                    <option
                      value="CS"
                      label="Serbia and Montenegro"
                      className="Europe"
                    >
                      Serbia and Montenegro
                    </option>
                    <option value="SK" label="Slovakia" className="Europe">
                      Slovakia
                    </option>
                    <option value="SI" label="Slovenia" className="Europe">
                      Slovenia
                    </option>
                    <option value="ES" label="Spain" className="Europe">
                      Spain
                    </option>
                    <option
                      value="SJ"
                      label="Svalbard and Jan Mayen"
                      className="Europe"
                    >
                      Svalbard and Jan Mayen
                    </option>
                    <option value="SE" label="Sweden" className="Europe">
                      Sweden
                    </option>
                    <option value="CH" label="Switzerland" className="Europe">
                      Switzerland
                    </option>
                    <option value="UA" label="Ukraine" className="Europe">
                      Ukraine
                    </option>
                    <option
                      value="SU"
                      label="Union of Soviet Socialist Republics"
                      className="Europe"
                    >
                      Union of Soviet Socialist Republics
                    </option>
                    <option
                      value="GB"
                      label="United Kingdom"
                      className="Europe"
                    >
                      United Kingdom
                    </option>
                    <option value="VA" label="Vatican City" className="Europe">
                      Vatican City
                    </option>
                    <option value="AX" label="Ãland Islands" className="Europe">
                      Ãland Islands
                    </option>
                    <option
                      value="AS"
                      className="Oceania"
                      label="American Samoa"
                    >
                      American Samoa
                    </option>
                    <option value="AQ" className="Oceania" label="Antarctica">
                      Antarctica
                    </option>
                    <option value="AU" className="Oceania" label="Australia">
                      Australia
                    </option>
                    <option
                      value="BV"
                      className="Oceania"
                      label="Bouvet Island"
                    >
                      Bouvet Island
                    </option>
                    <option
                      value="IO"
                      className="Oceania"
                      label="British Indian Ocean Territory"
                    >
                      British Indian Ocean Territory
                    </option>
                    <option
                      value="CX"
                      className="Oceania"
                      label="Christmas Island"
                    >
                      Christmas Island
                    </option>
                    <option
                      value="CC"
                      className="Oceania"
                      label="Cocos [Keeling] Islands"
                    >
                      Cocos [Keeling] Islands
                    </option>
                    <option value="CK" className="Oceania" label="Cook Islands">
                      Cook Islands
                    </option>
                    <option value="FJ" className="Oceania" label="Fiji">
                      Fiji
                    </option>
                    <option
                      value="PF"
                      className="Oceania"
                      label="French Polynesia"
                    >
                      French Polynesia
                    </option>
                    <option
                      value="TF"
                      className="Oceania"
                      label="French Southern Territories"
                    >
                      French Southern Territories
                    </option>
                    <option value="GU" className="Oceania" label="Guam">
                      Guam
                    </option>
                    <option
                      value="HM"
                      className="Oceania"
                      label="Heard Island and McDonald Islands"
                    >
                      Heard Island and McDonald Islands
                    </option>
                    <option value="KI" className="Oceania" label="Kiribati">
                      Kiribati
                    </option>
                    <option
                      value="MH"
                      className="Oceania"
                      label="Marshall Islands"
                    >
                      Marshall Islands
                    </option>
                    <option value="FM" className="Oceania" label="Micronesia">
                      Micronesia
                    </option>
                    <option value="NR" className="Oceania" label="Nauru">
                      Nauru
                    </option>
                    <option
                      value="NC"
                      className="Oceania"
                      label="New Caledonia"
                    >
                      New Caledonia
                    </option>
                    <option value="NZ" className="Oceania" label="New Zealand">
                      New Zealand
                    </option>
                    <option value="NU" className="Oceania" label="Niue">
                      Niue
                    </option>
                    <option
                      value="NF"
                      className="Oceania"
                      label="Norfolk Island"
                    >
                      Norfolk Island
                    </option>
                    <option
                      value="MP"
                      className="Oceania"
                      label="Northern Mariana Islands"
                    >
                      Northern Mariana Islands
                    </option>
                    <option value="PW" className="Oceania" label="Palau">
                      Palau
                    </option>
                    <option
                      value="PG"
                      className="Oceania"
                      label="Papua New Guinea"
                    >
                      Papua New Guinea
                    </option>
                    <option
                      value="PN"
                      className="Oceania"
                      label="Pitcairn Islands"
                    >
                      Pitcairn Islands
                    </option>
                    <option value="WS" className="Oceania" label="Samoa">
                      Samoa
                    </option>
                    <option
                      value="SB"
                      className="Oceania"
                      label="Solomon Islands"
                    >
                      Solomon Islands
                    </option>
                    <option
                      value="GS"
                      className="Oceania"
                      label="South Georgia and the South Sandwich Islands"
                    >
                      South Georgia and the South Sandwich Islands
                    </option>
                    <option value="TK" className="Oceania" label="Tokelau">
                      Tokelau
                    </option>
                    <option value="TO" className="Oceania" label="Tonga">
                      Tonga
                    </option>
                    <option value="TV" className="Oceania" label="Tuvalu">
                      Tuvalu
                    </option>
                    <option
                      value="UM"
                      className="Oceania"
                      label="U.S. Minor Outlying Islands"
                    >
                      U.S. Minor Outlying Islands
                    </option>
                    <option value="VU" className="Oceania" label="Vanuatu">
                      Vanuatu
                    </option>
                    <option
                      value="WF"
                      className="Oceania"
                      label="Wallis and Futuna"
                    >
                      Wallis and Futuna
                    </option>
                  </select>
                </div>
              </div>

              {/* <div className="row align-items-end">
                                    <div className="col-9">
                                        <label htmlFor="referralCodes" className="form-label">추천인ID</label>
                                        <input
                                            type="text" className="form-control box" id="inviterEmail"
                                            placeholder="추천인ID 입력" value={inviterEmail} name="inviterEmail" onChange={handleChange} />
                                    </div>
                                    <div className="col-3">
                                        <input type="hidden" name="inviterEmailVerify" value={inviterEmailVerify}></input>
                                        <label htmlFor="userMailCheck" className="form-label"> </label>
                                        <button type="button" className="btn basicBtn sendUserMailCheck w-100" onClick={checkInviterEmail}>확인</button>
                                    </div>
                                </div> */}

              <div id="twoLevel_bottom">
                <div className="mb-3 term-box">
                  <input
                    type="checkbox"
                    id="privacyTerm1"
                    name="privacyTerm1"
                    className="m-2"
                    required
                  />
                  <label htmlFor="privacyTerm1"></label>
                  <span onClick={() => $("#privacyTerm1").trigger("click")}>
                    <b>
                      <a
                        onClick={() =>
                          window.open(
                            "/terms/termsOfUse",
                            "[밈비]이용약관",
                            "width=600, height=700, location=no,status=no, scrollbars=yes"
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        이용약관
                      </a>
                    </b>{" "}
                    및{" "}
                    <b>
                      <a
                        onClick={() =>
                          window.open(
                            "/terms/termsOfPrivacy",
                            "[밈비]개인정보처리방침",
                            "width=600, height=700, location=no,status=no, scrollbars=yes"
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        개인정보 처리방침
                      </a>
                    </b>
                    에 동의합니다.
                  </span>
                  <div className="invalid-feedback pw_cf">
                    *필수 약관에 동의해주세요.
                  </div>
                </div>
                <div className="mb-3 term-box">
                  <input
                    type="checkbox"
                    id="privacyTerm2"
                    name="privacyTerm2"
                    className="m-2"
                    required
                  />
                  <label htmlFor="privacyTerm2"></label>
                  <span onClick={() => $("#privacyTerm2").trigger("click")}>
                    19세 이상임을 확인합니다.
                  </span>
                  <div className="invalid-feedback pw_cf">
                    *필수 약관에 동의해주세요.
                  </div>
                </div>
              </div>

              <hr className="my-4" />
              <button
                className="w-100 btn btn-lg basicBtn mb-3 bg-primary btn-primary"
                id="createAccountBtn"
                type="button"
                onClick={joinFunc}
              >
                회원가입
              </button>

              <p className="py-2 text-center">
                이미 회원이신가요?{" "}
                <a href="login" style={{ color: "#fff" }}>
                  로그인
                </a>
              </p>
            </form>
          </div>
        </content>
      </div>
      <Footer />
      <script src="https://code.jquery.com/jquery-3.5.1.min.js"></script>
    </>
  );
};

export default Registration;
